export const WYSIWYG_SLUG = 'content'

export const ItemTypes = {
  BOX: 'box',
}